"use client"; 

import { useState } from 'react'
import useSWR from 'swr'

import { FunnelIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid';

import AutomationsGrid from '@/components/modules/automations/automationsGrid'
import AutomationsGridSuspense from '@/components/modules/automations/automationsGridSuspense';
import AppLogo from '@/components/modules/apps/logo'

import logger from '@/lib/logger'
import { classNames } from '@/lib/helpers'
import { stringifyQuery, getUrlFromQueryString } from '@/lib/database/helpers'


const EXT_AUTOMATIONS_API_CHUNK = 3*3*4  // This is How Much API Loads (Or getstaticProps at the beginning)
const EXT_AUTOMATIONS_CHUNK = 3*3  // For Show More
const MAX_APPS_SELECTED = 3
const MAX_APPS_GRID_CHUNK = 8*8


export default function ExternalAutomations (
  { apps=[], externalAutomations: externalAutomationsInitial=[] }: 
  { apps: any[], externalAutomations: any[] }
  ) {

  const lgrPx = 'Page.IntegrationsPage.'
  logger.info(`${lgrPx} rendering.`)

  // let externalAutomations = externalAutomationsInitial

  // FILTER PANEL SHOW/HIDE 
  const [showFilters, setShowFilters] = useState(false)
  
  // SEARCH TEXT 
  const [searchText, setSearchText] = useState('')
  const [searchAppText, setSearchAppText] = useState('')  // to filter apps 
  
  // SELECTED APPS 
  const [appsSelected, setAppsSelected] = useState<any>([])
  // apps?.slice(0,2)

  let appsSelectAvailable = apps?.filter(app => !appsSelected?.map(x => x?.id)?.includes(app?.id))
  appsSelectAvailable = appsSelectAvailable?.filter(app => app?.name?.toLowerCase()?.includes(searchAppText?.toLowerCase()))
  
  // FETCH DATA
  const query = {
    take: EXT_AUTOMATIONS_API_CHUNK,
    ...(searchText && { text: searchText }),
    ...(appsSelected?.length>0 && { apps: appsSelected?.map(x => x?.id)?.join() }),
  }
  
  const searchDataQueryString = stringifyQuery(query)
  const searchDataURL = getUrlFromQueryString('automations', searchDataQueryString)
  const shouldFetch = searchText || appsSelected?.length>0 ? true : false

  const { data: externalAutomationsFetched, error: externalAutomationsFetchError } = useSWR(shouldFetch ? [searchDataURL] : null) 
  const externalAutomations = shouldFetch ? externalAutomationsFetched : externalAutomationsInitial
  const isLoading = !externalAutomationsFetchError && !externalAutomationsFetched

  


  return (
    <div className="bg-white border-t border-gray-200">
      <div className="py-6 mx-auto max-w-7xl px-6 xl:px-8 ">


        {/* TOP BLOCK NEW  */}
        <div className=" bg-gray-100 rounded border border-gray-200">
          
          {/* Button and Text Input */}
          <div className="mx-3 py-1 flex flex-wrap gap-x-3 ">
            
            {/* Show/Hide Filter Button */}
            <button
              type="button"
              onClick={ () => setShowFilters(!showFilters) }
              className={classNames(true ? '' : '', 
                "my-2 px-6 py-2 relative inline-flex items-center  \
                rounded border border-gray-300 bg-transparent text-sm font-medium text-gray-700 hover:bg-gray-50 \
                focus:outline-none")}
            >
              {/* className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" */}
              <FunnelIcon className="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
              <span>{showFilters ? 'Hide' : 'Show'}</span>
              &nbsp;
              <span className="hidden sm:flex">Filters</span>
            </button> 

            {/* Search Text Input */}
            <div className="my-2 relative flex  items-stretch flex-grow focus-within:z-10">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
              <input
                name="search_text"
                id="search_text"
                className="block w-full pl-10 pr-3 py-2 sm:text-sm border border-gray-300 rounded leading-5 bg-white shadow-sm placeholder-gray-500 
                  focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-crisp-600 focus:border-crisp-600 " 
                placeholder='Search Automations'            
                onChange={(e) => { setSearchText(e.target.value) }}
                onClick={ () => {} }
              />

              {/* <input
                type="email"
                name="email"
                id="email"
                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 sm:text-sm border-gray-300"
                placeholder="John Smith"
              /> */}
            </div>

            {/* Apps selected  */}
            <div className="my-2">
              <div className="flex flex-wrap items-center">
                {appsSelected.map((app) => (
                  <span
                    key={app?.slug}
                    className="mx-1 my-0.5 py-1.5 pl-3 pr-2 inline-flex rounded-full border border-gray-200 items-center  text-sm font-medium bg-white text-gray-900"
                  >
                    <span>{app?.name}</span>
                    <button
                      type="button"
                      className="flex-shrink-0 ml-1 h-4 w-4 p-1 rounded-full inline-flex text-gray-400 hover:bg-gray-200 hover:text-gray-500"
                      onClick={ () => setAppsSelected(appsSelected?.filter(a => a?.id !== app?.id)) }
                    >
                      <span className="sr-only">
                        Remove filter for {app?.name}
                      </span>
                      <svg className="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                        <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7" />
                      </svg>
                    </button>
                  </span>
                ))}
              </div>
            </div>
          </div>
          
          {showFilters && (
            <div className="bg-white border-t border-gray-200">
              {/* Search App Input */}                    
              <div className="py-3 px-3  mx-auto sm:flex sm:items-center border-b border-gray-200">                                    
                <div className="w-full">
                  <div className="relative flex items-stretch flex-grow ">
                
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>

                    <input
                      name="search_app"
                      id="search_app"
                      className="block w-full pl-10 pr-3 py-2 sm:text-sm border border-gray-300 rounded leading-5 bg-white shadow-sm placeholder-gray-500 
                      focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-crisp-600 focus:border-crisp-600 " 
                      placeholder='Filter by apps'
                      value={searchAppText}
                      onChange={(e) => { setSearchAppText(e.target.value) }}     
                    />

                  </div>
                </div>
              </div>

              {/* Apps Grid */}
              <div className="px-3 py-3 text-center ">
                {appsSelected?.length >= MAX_APPS_SELECTED ? (
                  <p className="text-base text-gray-500 text-left">
                          Please choose maximum {MAX_APPS_SELECTED} apps
                  </p>
                ) : (
                  <ul role="list" className="overflow-y-auto h-32 sm:h-40 lg:h-64 mx-auto grid grid-cols-4 sm:grid-cols-4  xl:grid-cols-8   gap-x-4 gap-y-4">                      
                    {appsSelectAvailable?.slice(0,MAX_APPS_GRID_CHUNK)?.map((app) => (
                      <li key={app?.slug} 
                          className={classNames(false ? 'bg-green-400 hover:bg-green-400' : 'bg-white hover:bg-gray-100', 
                          classNames(false ? 'animate-pulse' : '', 'h-fit relative rounded border hover:shadow-lg'))}
                      >
                        {/* animate-pulse */}
                        <div className="">
                          
                          <div className="pt-3">
                            <AppLogo className="h-10 w-10 rounded mx-auto" app={app}/>
                          </div>
                          
                          <div className="px-2 hover:cursor-pointer">
                            {/* a href='#' */}
                            <div 
                              className="focus:outline-none"
                              onClick={ (e) => { 
                                e.preventDefault();
                                if (appsSelected?.length < MAX_APPS_SELECTED) setAppsSelected([...appsSelected, app]);
                                setSearchAppText('')
                              } }
                            >
                              <span className="absolute inset-0" aria-hidden="true" />
                            </div>
                            <p className="pb-2 text-sm text-gray-600  truncate">
                              {app.name}
                            </p>
                          </div>

                        </div>
                        
                        {/* <span className="absolute top-0 right-0 block h-4 w-4 transform -translate-y-1/2 translate-x-1/2 rounded-full ring-2 ring-white bg-green-400" /> */}

                      </li>
                    ))}
                  </ul>
                )}

              </div>

            </div>
          )}

        </div>



        {/* TWO COLUMN LAYOUT  */}
        <div className="space-y-6">

          {shouldFetch && isLoading ? (
            <AutomationsGridSuspense placeholder={9}/>
          ) : (
            <>
              {externalAutomations?.length>0 && (
                <h2 className="mt-6 text-3xl font-semibold tracking-tight text-gray-900">
                  Popular automation templates
                </h2>
              )}
              <AutomationsGrid 
                externalAutomations={externalAutomations} 
                chunk={EXT_AUTOMATIONS_CHUNK} 
                showMore={true} 
                showEmpty={true} 
              />
            </>
          )}

          
        </div>

      </div>



    </div>
  )
}